import React from 'react';
import CriticalInfoModal from '../Components/CriticalInfoModal';

const CriticalGuard = () => {
  return <CriticalInfoModal />;
};

export default CriticalGuard;
